module.exports = __webpack_public_path__ + "assets/img/contraband.953417c7.png";